if (!customElements.get('variant-pills')) {
  class VariantPills extends HTMLElement {
    constructor() {
      super();
      this.pills = this.querySelectorAll('.variant-pill:not(.variant-pill--unavailable)');
      this.hiddenInput = this.closest('form')?.querySelector('input[name="id"]');
      this.priceContainer = this.closest('.card-wrapper')?.querySelector('.price');
      this.submitBtn = this.closest('form')?.querySelector('[type="submit"]');
      this.variantData = JSON.parse(this.dataset.variants || '[]');

      this.pills.forEach((pill) => {
        pill.addEventListener('click', this.onPillClick.bind(this));
      });
    }

    onPillClick(event) {
      const pill = event.currentTarget;
      const variantId = pill.dataset.variantId;
      const variant = this.variantData.find((v) => String(v.id) === variantId);

      if (!variant) return;

      // Update active state
      this.querySelectorAll('.variant-pill').forEach((p) => p.classList.remove('variant-pill--active'));
      pill.classList.add('variant-pill--active');

      // Update hidden variant ID
      if (this.hiddenInput) {
        this.hiddenInput.value = variantId;
      }

      // Update price display
      this.updatePrice(variant);

      // Update button state
      if (this.submitBtn) {
        const spanEl = this.submitBtn.querySelector('span:not(.sold-out-message)');
        const soldOutSpan = this.submitBtn.querySelector('.sold-out-message');
        if (variant.available) {
          this.submitBtn.disabled = false;
          if (spanEl) spanEl.textContent = this.submitBtn.dataset.addText || 'Adauga in cos';
          if (soldOutSpan) soldOutSpan.classList.add('hidden');
        } else {
          this.submitBtn.disabled = true;
          if (spanEl) spanEl.textContent = this.submitBtn.dataset.soldText || 'Stoc epuizat';
        }
      }
    }

    updatePrice(variant) {
      if (!this.priceContainer) return;

      const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      // Toggle sale/regular visibility via Dawn's price classes
      if (isOnSale) {
        this.priceContainer.classList.add('price--on-sale');
      } else {
        this.priceContainer.classList.remove('price--on-sale');
      }

      // Update regular price (shown when no sale)
      const regularPriceEl = this.priceContainer.querySelector('.price__regular .price-item--regular');
      if (regularPriceEl) {
        regularPriceEl.textContent = this.formatMoney(variant.price);
      }

      // Update sale section
      const salePriceEl = this.priceContainer.querySelector('.price__sale .price-item--sale');
      if (salePriceEl) {
        salePriceEl.textContent = this.formatMoney(variant.price);
      }

      const compareEl = this.priceContainer.querySelector('.price__sale .price-item--regular');
      if (compareEl && isOnSale) {
        compareEl.textContent = this.formatMoney(variant.compare_at_price);
      }

      // Update sold-out state
      if (!variant.available) {
        this.priceContainer.classList.add('price--sold-out');
      } else {
        this.priceContainer.classList.remove('price--sold-out');
      }
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' ' + (Shopify.currency?.active || 'RON');
    }
  }

  customElements.define('variant-pills', VariantPills);
}
